import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Site = {
  themeJson?: Record<string, unknown> | null;
};

export default function ThemePage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<Site>("/api/v1/tenant/site");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("theme.title")}</h1>
      {loading && <p className="mt-4 text-slate-500">{t("common.loading")}</p>}
      {error && <p className="mt-4 text-red-600">{error}</p>}
      {!loading && !error && !data?.themeJson && (
        <p className="mt-4 text-slate-500">{t("theme.empty")}</p>
      )}
      {data?.themeJson && (
        <pre className="mt-4 max-h-[60vh] overflow-auto rounded-md border border-slate-200 bg-white p-4 text-xs text-slate-700">
          {JSON.stringify(data.themeJson, null, 2)}
        </pre>
      )}
    </div>
  );
}
